const TIPOS_DILIGENCIAS_ESTADO = [
  {
    id: 0,
    name: 'Pendiente'
  },
  {
    id: 1,
    name: 'Correcta'
  },
  {
    id: 2,
    name: 'En Error'
  },
  {
    id: 3,
    name: 'Revisada'
  },
]

export {
  TIPOS_DILIGENCIAS_ESTADO
}
